import { getTransactionAnalytics } from '@ynap/analytics'

export const trackDDUDisplayed = (checkoutAnalytics) => ({
    event: 'ddu - messaging displayed',
    effect: 'prompt user to accept ddu conditions',
    category: {
        primaryCategory: 'checkout',
        subCategory: 'shipping address'
    },
    transaction: getTransactionAnalytics(checkoutAnalytics)
})

export const trackDDUAccepted = (checkoutAnalytics) => ({
    event: 'ddu - conditions accepted',
    effect: 'tickbox selection',
    category: {
        primaryCategory: 'checkout',
        subCategory: 'shipping address'
    },
    transaction: getTransactionAnalytics(checkoutAnalytics)
})

export const trackDDUError = (checkoutAnalytics) => ({
    event: 'ddu - acceptance error',
    effect: 'user experienced error',
    category: {
        primaryCategory: 'checkout',
        subCategory: 'shipping address'
    },
    transaction: getTransactionAnalytics(checkoutAnalytics)
})